import { merchantIcons } from '@assets/icons';
import { memo } from 'react';
import { useNavigate } from 'react-router';

const OnboardingBackLink = memo(({ to, label = 'Go Back', state }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to, state ? { state } : undefined)}
      className="flex w-full cursor-pointer items-center gap-1.5 desktop:gap-2 py-2.5 desktop:py-3 text-left transition-opacity hover:opacity-70"
    >
      <img src={merchantIcons.arrowLeft} alt="" className="icon-md shrink-0" aria-hidden="true" />
      <span className="desktop:text-[16px] text-sm font-medium leading-normal text-merchant-text-secondary">
        {label}
      </span>
    </button>
  );
});

OnboardingBackLink.displayName = 'OnboardingBackLink';

export default OnboardingBackLink;
